<template>
  <div id="my-toast-box" :class="{ pcStyle: isPc, mobileStyle: isMobile }">
    <div class="my-toast-content">
      <div id="my-toast-title"></div>
    </div>
  </div>
</template>

<script>
import ResizeMixin from '@/mixin/ResizeHandler';
export default {
  name: 'live-video',
  mixins: [ResizeMixin],
};
</script>

<style lang="less" scoped>
#my-toast-box {
  display: none;
  .my-toast-content {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10010;
    justify-content: center;
    align-items: center;
    display: -webkit-flex;

    #my-toast-title {
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      padding: 10px 14px;
      font-size: 14px;
      border-radius: 5px;
      max-width: 70vw;
      word-break: break-all;
    }
  }
}

#my-toast-box.pcStyle {
  .my-toast-content {
    width: 100%;
    height: 100%;
    top: 0;
  }
  #my-toast-title {
    font-size: 15px;
    padding: 10px 20px;
  }
}
</style>
